<template>
<div class="home guide-page page-template-default page separate-containers nav-below-header">
  <HeadNav selectedLanguage="en" page="guide" />

  <GuideBreadcrumb :items="breadcrumbItems" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <section class="entry-wrapper hero">
            <div class="hero-shell hero-shell--guide">
              <header class="hero-top">
                <h1>{{ page.h1 }}</h1>
              </header>
            </div>
          </section>

          <div v-for="(section, idx) in pageSections" :key="idx" class="section-content">
            <h2 v-if="section.h2" class="h">{{ section.h2 }}</h2>
            <p v-for="(p, pi) in section.paragraphs || []" :key="'p' + pi" v-html="p" />
            <ul v-if="section.list" class="check-list">
              <li v-for="(item, li) in section.list" :key="li" v-html="item" />
            </ul>
            <ol v-if="section.steps" class="step-cards">
              <li v-for="(step, si) in section.steps" :key="si" v-html="step" />
            </ol>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gb-home-layout.scss'
import '@/css/guide-pages.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import { CORE_SUB_PAGES } from '@/data/corePages'

export default {
  name: 'CoreSubPage',
  components: { HeadNav, GuideBreadcrumb },
  computed: {
    page() {
      const key = this.$route.meta.subPageKey
      return (
        CORE_SUB_PAGES[key] || {
          h1: 'Help',
          sections: [{ paragraphs: ['Content not found.'] }],
        }
      )
    },
    pageSections() {
      if (this.page.sections) return this.page.sections
      if (this.page.paragraphs) return [{ paragraphs: this.page.paragraphs }]
      return []
    },
    breadcrumbItems() {
      const items = [{ label: 'Home', href: '/' }]
      if (this.page.parent) {
        items.push({ label: this.page.parent.label, href: this.page.parent.href })
      }
      items.push({ label: this.page.h1 })
      return items
    },
  },
}
</script>
